<template>

    <div class="px-4 py-5 my-5 text-center">
        <b-icon icon="exclamation-circle" style="width: 100px; height: 100px;"></b-icon>

        <div v-if="!is_excel">
            <h1 class="display-5 fw-bold mt-3">
                {{__t('POS_NOT_ATTACHED')}}
            </h1>
            <div class="col-lg-6 mx-auto">
                <p class="lead mb-4">
                    {{__t('CREATE_POS_HOW')}}
                </p>
                <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
                    <div id="confirmButton" class="btn btn-primary btn-lg px-4 me-sm-3 emptystate-btnadd" v-on:click="show_settings">
                        {{__t('CREATE_POS_SETTINGS')}}
                    </div>

                    <div class="btn btn-outline-success btn-lg px-4 me-sm-3 ml-2 emptystate-btnadd" v-on:click="show_register" v-if="has_register">
                        {{__t('AUTH_POS')}}
                    </div>

                </div>
            </div>

            <user_password></user_password>
        </div>

        <div v-else>
            <h1 class="display-5 fw-bold mt-3">
                {{__t('UPLOAD_FILE')}}
            </h1>

            <fileload @finish_load="finish_load" :doc_id="cur_provider_id" doc_type="feed" :url_load="'pos/upload/feed'"></fileload>
        </div>

    </div>
</template>

<script>
import User_password from "./oauth/user_password.vue";
import Fileload from "../sys/file_loader/fileload.vue";
export default {
    name: "pos_empty",
    components: {Fileload, User_password},
    props : {
        pos_item : {
            type : Object
        }
    },
    methods : {
        show_settings() {
            EventBus.$emit('pos_edit');
        },

        show_register() {
            if(this.cur_provider == 'poster') {
                this.show_poster_register();
            }

            if(this.cur_provider === 'dotykacka' || this.cur_provider === 'square') {
                this.go_auth(this.cur_provider);
            }
        },


        async go_auth(type) {
            await api.post('/internal/oauth/'+ type +'/redirect').then(({data}) => {
                if(data.status == "operation_success") {
                    let resp = data.data;
                    if(resp.hasOwnProperty("redirect")) {
                        window.open(resp.redirect);
                    }
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        show_poster_register() {
            EventBus.$emit('poster_refresh');
        },

        finish_load(file) {
            this.$emit('excel_ready',file);
        }

    },
    computed : {
        cur_provider() {
            return this.pos_item.provider.type;
        },

        cur_provider_id() {
            return this.pos_item.provider.id;
        },

        has_register() {
          return  this.cur_provider == 'poster' || this.cur_provider == 'square' || this.cur_provider == 'dotykacka';
        },

        is_excel() {
            return this.cur_provider === 'excel' || this.cur_provider == 'smok';
        },
    },
}
</script>

<style scoped>

</style>
